import { Expression } from "./abstract.expression";
export class ConstantExpression implements Expression
{
    constructor(public readonly expression: string) {}

    toQuery(): string
    {
        return this.expression;
    }
}
